import { injectable } from 'tsyringe';
import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';

export type HealthStatus = 'healthy' | 'degraded' | 'unhealthy';

export interface PlatformServiceHealth {
    key: string;
    name: string;
    detail: string;
    status: HealthStatus;
    latencyMs: number;
}

export interface PlatformHealthStatus {
    mode: 'saas' | 'self-hosted';
    version: string;
    overall: HealthStatus;
    checkedAt: string;
    services: PlatformServiceHealth[];
}

/**
 * Reads live platform health for the System > Overview page from bmai-notifications
 * over the BFF. The endpoint probes each core service's readiness on demand.
 */
@injectable()
export class SystemHealthService {
    async getHealth(): Promise<PlatformHealthStatus> {
        const res = await authenticatedFetch('/_notifications/api/notifications/platform/health');
        if (!res.ok) {
            let message = `Failed to load system health (${res.status})`;
            try {
                const body = (await res.json()) as { error?: string };
                if (body.error) message = body.error;
            } catch { void 0; }
            throw new Error(message);
        }
        return (await res.json()) as PlatformHealthStatus;
    }
}
